import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { LoadingSpinner } from '@parkhub/parkhub-ui';
import { OverviewDialog } from '../../components';
import { getOrganizations } from '../../actions/organizations.action';
import TreeContainer from '../../components/TreeContainer/TreeContainer';
import TreePicker from '../../components/TreePicker/TreePicker';
import { setSearchTerm, clearSearchTerm } from '../../actions/filter.action';
import { buildTree } from '../../actions/tree.action';
import StepWizard from 'react-step-wizard';
import './OrganizationsTree.scss';

class OrganizationsTree extends Component {

  render() {
    const { actions, dialogVisible, dialogTitle, dialogContent } = this.props;
    const orgActions = {
      hide: actions.hide,
      show: actions.show,
      hideDisable: actions.hideDisable,
      showDisable: actions.showDisable
    };

    const TreeSteps = [
      <TreePicker
        key={1}
        buildTree={this.props.buildTree}
        organizations={this.props.organizations}
        getOrganizations={this.props.getOrganizations}
        orgList={this.props.orgList}
        data={this.props.data}
      />,
      <TreeContainer
        key={2}
        data={this.props.organizationTree}
        clearSearchTerm={this.props.clearSearchTerm}
      />
    ];

    return (
      <Fragment>
        <StepWizard id="wizard" children={TreeSteps} />
        <OverviewDialog
          visible={dialogVisible}
          onHide={orgActions.hide}
          data={dialogContent}
          title={dialogTitle}
        />
        <LoadingSpinner show={this.props.isLoading} delay={650} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.wizard.data,
  orgList: state.organizations.data,
  dialogVisible: state.wizard.visible,
  dialogContent: state.wizard.data,
  dialogTitle: state.wizard.title,
  organizations: state.organizations.organizations,
  tree: state.tree.oganizationTree,
  filteredData: state.tree.orgFilteredData,
  isLoading: state.organizations.isLoading,
  disableModalVisible: state.dialog.visible,
  organizationTree: state.tree.organizationTree,
  searchTerm: state.filter.searchTerm
});

export default connect(mapStateToProps, {
  setSearchTerm,
  clearSearchTerm,
  getOrganizations,
  buildTree
})(OrganizationsTree);



// WEBPACK FOOTER //
// ./src/containers/OrganizationsTree/OrganizationsTree.jsx